module.exports = __webpack_public_path__ + "static/img/home_zh.4436594.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home_zh.png
// module id = p2fa
// module chunks = 0